import React from 'react';
import PropTypes from 'prop-types';

import LabeledTextInput from 'components/consumer/LabeledTextInput';

const ShippingEmailField = ({
  id = 'shipping_email',
  name = 'shipping_email',
  value,
  error,
  isTouched,
  handleBlur,
  handleChange,
  isRequired = true,
}) => (
  <LabeledTextInput
    id={id}
    type="text"
    name={name}
    label="Shipping Email"
    onChange={handleChange}
    onBlur={handleBlur}
    value={value}
    data-xc="shipping-email-field"
    autoComplete="shipping-email"
    errorMessage={isTouched && error ? error : null}
    required={isRequired ? '' : undefined}
    aria-required={isRequired ? '' : undefined}
  />
);

ShippingEmailField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
};

export default ShippingEmailField;
